import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const JobseekersProgram = () => {
  const [bannerData, setBannerData] = useState(null);
  const [contentData, setContentData] = useState([]);

  // Fetch Banner
  useEffect(() => {
    fetch(
      "/prosapiens-cms/public/api/banners/jobseekers-1per-program"
    )
      .then((res) => res.json())
      .then((data) => {
        if (data?.banners?.length > 0) {
          setBannerData(data.banners[0]);
        }
      })
      .catch((err) => console.error("Error fetching banner data:", err));
  }, []);

  // Fetch Content
  useEffect(() => {
    fetch(
      "/prosapiens-cms/public/api/content/jobseekers-1per-program"
    )
      .then((res) => res.json())
      .then((data) => {
        if (data?.content?.length > 0) {
          setContentData(data.content);
        }
      })
      .catch((err) => console.error("Error fetching content data:", err));
  }, []);

  return (
    <div>
      {/* Banner Section */}
      <section
        className="jobseekers-1-program-banner"
        style={{
          backgroundImage: bannerData?.banner_image
            ? `url(/prosapiens-cms/public/${bannerData.banner_image})`
            : "none",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="overlay container">
          <div className="hero-text" data-aos="fade-up">
            {bannerData?.banner_title && <h1>{bannerData.banner_title}</h1>}
            {bannerData?.content_text && (
              <div
                style={{ color: "#fff" }}
                dangerouslySetInnerHTML={{ __html: bannerData.content_text }}
              />
            )}
          </div>
        </div>
      </section>

      {/* Dynamic Content Sections */}
      {contentData.map((item, index) => {
        // Image URL if available
        const imageUrl = item.content_image
          ? `/prosapiens-cms/public/${item.content_image}`
          : null;

        // For first section ("what-we-do"), use specific class
        if (item.content_order === "1") {
          return (
            <section className="what-we-do" key={item.id}>
              <div className="container">
                <div className="image-container">
                  {/* Image Side */}
                  {imageUrl && (
                    <div className="image-side" data-aos="fade-right">
                      <img
                        src={imageUrl}
                        alt={item.content_title || "Content Image"}
                      />
                    </div>
                  )}

                  {/* Text Side */}
                  <div className="text-side" data-aos="fade-left">
                    {/* {item.content_title && (
                      <div className="label">{item.content_title}</div>
                    )} */}
                    {/* If your API has headings, split or style them accordingly */}
                    <div
                      dangerouslySetInnerHTML={{ __html: item.content_text }}
                    />
                  </div>
                </div>
              </div>
            </section>
          );
        }

        // For second section ("smart-hiring-process")
        if (item.content_order === "2") {
          return (
            <div className="container" key={item.id}>
              <div dangerouslySetInnerHTML={{ __html: item.content_text }} />
            </div>
          );
        }

        // For third section ("company-one-sec")
        if (item.content_order === "3") {
          return (
            <section className="company-one-sec" key={item.id}>
              <div className="container">
                <div className="image-container">
                  {/* Text Side */}
                  <div className="text-side about" data-aos="fade-left">
                    {/* Dynamic Title */}
                    {/* {item.content_title && <h2>{item.content_title}</h2>} */}

                    {/* Dynamic List from HTML */}
                    <ul
                      className="features"
                      dangerouslySetInnerHTML={{ __html: item.content_text }}
                    />
                  </div>

                  {/* Image Side */}
                  {item.content_image && (
                    <div className="image-side" data-aos="fade-right">
                      <img
                        src={imageUrl}
                        alt={item.content_title || "Content Image"}
                      />
                    </div>
                  )}
                </div>
              </div>
            </section>
          );
        }

        // For fourth section ("hire-box")
        if (item.content_order === "4") {
          return (
            <div className="container" key={item.id} data-aos="fade-up">
              <div className="hire-box">
                <div dangerouslySetInnerHTML={{ __html: item.content_text }} />
                <Link to="/openings" className="cta-yellow">
                  APPLY NOW →
                </Link>
              </div>
            </div>
          );
        }

        return null;
      })}
    </div>
  );
};

export default JobseekersProgram;
